<template>
  <div class="md-layout-item" id="kanban">
    <div id="top"></div>
    <div>
      <tr>
        <th class="caption caption-border">
            Applications on your list
            <span class="count">
              {{ "(" }}
              <span v-if="applications.length == 0"> No items to display </span>
               <span v-else>
                Showing items {{ pagination_range_start + 1 }}-{{ pagination_range_end }} out of
                {{ pagination.total }} items
              </span>
              {{ ")" }}
            </span>
            <span class="count">
              <span><strong>Total Income: </strong> {{totalNafAndIncomes.totalIncomes | currency}} </span>
              <span><strong>Total NAF: </strong> {{totalNafAndIncomes.totalNaf | currency}} </span>
            </span>
            <span class="count">
              <strong>. On Page:</strong>
              <span> {{ page }}</span>
            </span>
          </th>
      </tr>
    </div>
    <div class="filter-toolbar md-layout align-center no-wrap">
      <!-- Arrows Left -->
      <span class="arrow-group">
        <md-button @click="goToPage(1)" class="md-icon-button md-primary md-simple" :disabled="page <= 1">
          <md-icon>first_page</md-icon>
        </md-button>
        <md-button @click="previousPage" class="md-icon-button md-primary md-simple" :disabled="page <= 1">
          <md-icon>navigate_before</md-icon>
        </md-button>
      </span>

      <!-- Page # -->
      <span class="page-selector">
        <validated-select-input
          label="Page #"
          v-model="page"
          :options="pages"
          :is_sortable="false"
        />
      </span>

      <!-- Arrows Right -->
      <span class="arrow-group">
        <md-button @click="nextPage" class="md-icon-button md-primary md-simple" :disabled="page >= page_count">
          <md-icon>navigate_next</md-icon>
        </md-button>
        <md-button @click="goToPage(-1)" class="md-icon-button md-primary md-simple" :disabled="page >= page_count">
          <md-icon>last_page</md-icon>
        </md-button>
      </span>

      <!-- Per Page -->
      <span class="narrow">
        <validated-select-input
          label="# Per Page"
          v-model="items_per_page"
          :options="items_per_page_options"
          :is_sortable="false"
          @input="handlePageChange()" />
      </span>

      <!-- Filter -->
      <span v-if="filterable" class="filter-field">
        <validated-text-input v-model="searchQuery" label="Filter...." class="placeholder" />
      </span>

      <!-- Columns -->
      <span class="column-selector">
        <md-field>
          <label for="show_columns">Show Columns</label>
          <md-select multiple v-model="selectedColumns">
            <md-option
              v-for="(column, key) in display_items"
              :key="key"
              :value="key"
            >
              {{ key }}
            </md-option>
          </md-select>
        </md-field>
      </span>
    </div>
    <!-- Kanban Header -->
    <div class="md-layout md-layout-item horizontal-scroll sticky-top" ref="topscroll">
      <div
        v-for="(applications, key) in display_items"
        :key="key"
        class="boxed-category md-layout-item md-medium-size-25 md-small-size-33 md-size-15"
        v-show="selectedColumns.includes(key)"
      >
        <md-subheader class="text-bold">
          <div>
            {{ key }}
          </div>
          <div class="application-count">
            <md-icon>description</md-icon>
            {{ applications.length }}
          </div>
        </md-subheader>
      </div>
    </div>
    <!-- Kanban content -->
    <div class="md-layout md-layout-item scrolls" ref="bottomscroll">
      <div
        v-for="(applications, key) in display_items"
        :key="key"
        class="boxed-category md-layout-item md-medium-size-25 md-small-size-33 md-size-15"
        v-show="selectedColumns.includes(key)"
      >
        <Draggable
          class="card-content min-height-100"
          :list="applications"
          :disabled="!userHasRole('Broker')"
          group="people"
          @change="log($event, key)"
        >
          <div
            v-for="(application, index) in applications"
            :key="index"
            :class="{ 'md-layout-item pipeline-list': true, 'grabbable': userHasRole('Broker') }"
          >
            <md-card :class="application.background_color">
              <div @dblclick="handleCardClick($event, application)">
              <md-card-header class="text-right">
                <!-- <div
                  class="card-container"
                  :style="{ 'align-items': checkboxVal[application.id] ? 'start' : 'center' }"
                  >
                  <md-checkbox
                    v-model="checkboxVal[application.id]"
                    @change="handleCheckboxChange(application.id)"
                  >
                  Next Action
                  </md-checkbox>
                  <div
                    class="card-container"
                    :style="{ 'align-items': checkboxVal[application.id] ? 'start' : 'center' }"
                    >
                    <md-checkbox
                      v-model="checkboxVal[application.id]"
                      @change="handleCheckboxChange(application.id)"
                    >
                    Next Action
                    </md-checkbox>
                    <div
                      v-if="checkboxVal[application.id] && datePickerVisibility[application.id]"
                    >
                      <div class="date-picker">
                        <v-date-picker
                          v-model="pickerVal[application.id]"
                        >
                        <div class="hour-container">
                          <md-field>
                            <md-input
                              v-model="timeNextAction.hour[application.id]"
                              placeholder="00"
                            />
                          </md-field>
                          <span>:</span>
                          <md-field>
                            <md-input
                              v-model="timeNextAction.minute[application.id]"
                              placeholder="00"
                            />
                          </md-field>
                          <md-field
                            class="save-button-field"
                          >
                            <md-button
                              class="save-button md-primary"
                              :disabled="false"
                              @click="handleFilterChange(application.id)"
                            >
                              Save
                            </md-button>
                          </md-field>
                        </div>
                        </v-date-picker>
                      </div>
                    </div>
                    <span :class="{ 'card-app-id': checkboxVal[application.id] }">{{ application.id }} </span>
                  </div>
                  <span :class="{ 'card-app-id': checkboxVal[application.id] }">{{ application.id }} </span>
                </div> -->
                <div class="row-space-between">
                  <span style="display:flex; justify-content:space-evenly;">
                    <md-tooltip md-direction="left">ID Docs</md-tooltip>
                    <md-icon class="md-icon md-icon-font md-theme-default" :style="application.badge_flag == 1 ? {'color' : '#4caf50'} : {'color' : '#696969'}">badge</md-icon>
                    <md-tooltip md-direction="right">Financial Docs</md-tooltip>
                    <md-icon class="md-icon md-icon-font md-theme-default" :style="application.request_quote_flag == 1 ? {'color' : '#4caf50'} : {'color' : '#696969'}">request_quote</md-icon>
                  </span>
                  <span>{{ application.id }}</span>
                </div>
                <div class="md-subhead long-text">{{ referrerName(application.owners) }}</div>
                <div class="md-title long-text">{{ application.name | name }}</div>
                <div class="row-end">
                  <button class="button-copy"
                    @click="copyToClipboard(application.contact_details.phone_number, application.id)"
                  >
                    {{ isCopied(application.contact_details.phone_number) ? "Copied" : "Copy" }}
                  </button>
                  <div class="md-subhead long-text">{{ application.contact_details.phone_number }}</div>
                </div>
                <div class="row-end">
                  <button
                    class="button-copy"
                    @click="copyToClipboard(application.contact_details.email, application.id)"
                  >
                    {{ isCopied(application.contact_details.email) ? "Copied" : "Copy" }}
                  </button>
                  <div class="md-subhead long-text">{{ application.contact_details.email }}</div>
                </div>
                <div class="md-subhead" v-if="applicationData[application.id] && applicationData[application.id].nextActionDate"><b>Next Action: </b>
                  {{ datetime(applicationData[application.id].nextActionDate) }}
                </div>
              </md-card-header>
              <md-card-content>
                <md-divider></md-divider>
                <div class="md-layout md-gutter">
                  <div class="md-layout-item md-size-50">{{ application.asset_type}}</div>
                  <div class="md-layout-item md-size-50 card-currency-wrapper">
                    <span>{{ application.naf | currency }}</span>
                    <span >{{ getIncome(application) | currency }}</span>
                  </div>
                </div>
              </md-card-content>
              <div class="card-menu-wrapper">
                <loading-icon-button
                  @click="triggerManageComment(application)"
                  tooltip="Manage the loan application comments"
                  :disabled="isLoading"
                  :loading="isLoading && showCommentIcons.includes(application.id)"
                >
                  comment
                </loading-icon-button>
                <div v-if="application.veda_score" class="card-veda-wrapper">
                  <span>Equifax 2.0</span>
                  <span>{{ application.veda_score }}</span>
                </div>
                <md-menu md-size="medium" md-direction="bottom-start" class="action-menu" @click="getAppPermissions(application)">
                    <loading-icon-button md-menu-trigger tooltip="Click the 3 dots to see more"
                      :disabled="isLoading"
                    >
                      more_horiz
                    </loading-icon-button>

                    <md-menu-content class="action-menu" v-show="!isLoading">
                      <md-menu-item @click="triggerEdit(application)">
                        <md-tooltip md-direction="left">Edit the loan application</md-tooltip>
                        <md-icon>edit</md-icon>
                        Edit Application
                      </md-menu-item>
                      <md-menu-item @click="triggerOpen(application)" tooltip="Open Summary">
                        <md-tooltip md-direction="left">Go to the loan application summary page</md-tooltip>
                        <md-icon>launch</md-icon>
                        Open Summary
                      </md-menu-item>
                      <md-menu-item @click="triggerUpdateStatus(application)">
                        <md-tooltip md-direction="left">Update the status of the application</md-tooltip>
                        <md-icon>update</md-icon>
                        Update Status
                      </md-menu-item>
                      <md-menu-item @click="triggerManageOwners(application)">
                        <md-tooltip md-direction="left">Manage the loan application owners</md-tooltip>
                        <md-icon>manage_accounts</md-icon>
                        Manage Owners
                      </md-menu-item>
                      <md-menu-item @click="triggerAttachment(application)">
                        <md-tooltip md-direction="left">Manage application documents</md-tooltip>
                        <md-icon>attach_file</md-icon>
                        Attachments
                      </md-menu-item>
                      <md-menu-item @click="triggerCloneApplication(application)">
                        <md-tooltip md-direction="left">Clone Application</md-tooltip>
                        <md-icon>file_copy</md-icon>
                        Clone Application
                      </md-menu-item>
                    </md-menu-content>
                  </md-menu>
                </div>
              </div>
            </md-card>
          </div>
        </Draggable>
      </div>
    </div>
    <!-- Back to Top Button -->
    <div class="back-to-top" v-scroll-to="{el: '#top', container: '.scroll-area'}">
      <md-icon style="color: white">arrow_upward</md-icon>
      <md-tooltip md-direction="left">Back To Top</md-tooltip>
    </div>
  </div>
</template>
<script>
import {mapGetters} from 'vuex';
import filters from "@/components/utils/filters";
import ValidatedInputs from "@/components/ValidatedInput";
import Draggable from "vuedraggable";
import LoadingIconButton from "@/components/LoadingIconButton";
import AlertDialog from "@/components/Dialogs/AlertDialog";

export default {
  order: 1,
  components: {
    LoadingIconButton,
    ...ValidatedInputs,
    AlertDialog,
    Draggable,
  },
  props: {
    items: {
      type: Object,
      default: () => ({}),
    },
    loading: {
      type: null,
      default: () => null,
    },
    filterable: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      isLoading: false,
      removedElement: undefined,
      addedElement: undefined,
      moveInfo: {
        shouldMoveToBottom: null,
        applicationIdToMove: null,
      },
      datePickerVisibility: {},
      pickerVal: {},
      timeNextAction: {
        hour: {},
        minute: {}
      },
      copiedItems: [],
      checkboxVal: {},
      showCommentIcons: [],
      actions: {
        update: "update",
        view: "view",
        transfer: "transfer",
        update_status: "update-status",
        archive: "archive",
        un_archive: "un-archive",
        manage_owners: "manage-owners",
        attachments:"attachments",
        comment: "comment",
        clone: "clone",
      },
      searchQuery: "",
      brokerAppStages: [
        "Assigned To Broker",
        "In Progress",
        "Waiting for Info",
        "Submitted",
        "Approved/Conditional",
        "Docs Generated",
        "Docs Out",
        "In For Settlement",  
        "Settlement",
        "Compliance"
      ],
      selectedColumns: [],
      applications: [],
      items_per_page: 50,
      page: 1,
      totalPages: 1,
      applicationBasedOnStatus: {}
    }
  },
  computed: {
    ...mapGetters([
      "userHasPermission",
      "userHasRole",
      "getApplicationNextActionData",
      "getAllApplicationsNextActionData",
      "selected_pipeline_columns"
    ]),
    applicationData() {
      return this.getAllApplicationsNextActionData;
    },
    is_paginated() {
      return this.items_per_page && Number(this.items_per_page);
    },
    pagination_range_start() {
      return (this.pagination.page - 1) * this.pagination.per_page;
    },
    pagination_range_end() {
      return Math.min(this.pagination.per_page * this.pagination.page, this.pagination.total);
    },
    pagination() {
      return this.$store.state.pagination;
    },
    page_count() {
      return Math.ceil(this.pagination.total / this.pagination.per_page) || 1;
    },
    pages() {
      return Array.from({ length: this.page_count }, (_, index) => index + 1);
    },
    items_per_page_options() {
      let options = [10, 50, 100, 500, 1000];

      if (this.items_per_page && !options.includes(this.items_per_page)) {
        options.push(this.items_per_page);
      }

      options.sort((a, b) => (a > b ? 1 : a < b ? -1 : 0));
      return options;
    },
    totalNafAndIncomes() {
      let total = {
        totalNaf : 0,
        totalIncomes : 0,
      }
      this.applications.forEach(item=>{
        if (item.broker_incomes) {
          total.totalIncomes = total.totalIncomes + item.broker_incomes.reduce((sum, current) => sum + parseFloat(current.income_amount), 0);
        }
        if (item.naf) {
          total.totalNaf = total.totalNaf + parseFloat(item.naf);
        }
      });
      return total;
    },
    display_items() {
      let applicationWithStages = { ...this.applicationBasedOnStatus  };

      if (this.searchQuery.length > 0 && this.filterable) {
        for (let stage in applicationWithStages) {
          applicationWithStages[stage] = applicationWithStages[stage].filter(application => {
            const filteredValues = this.getFilteredValues(application);
            return filteredValues.some(value =>
              value.toLowerCase().includes(this.searchQuery.toLowerCase())
            );
          });
        }
      }

      for (let stage in applicationWithStages) {
        applicationWithStages[stage].forEach(application => {
          switch (application.status.status) {
            case 'Assigned To Broker':
              application.background_color = "bg-blue";
              break;
            case 'Submitted':
              application.background_color = "bg-orange-light";
              break;
            case 'In Progress':
              if (application.status.stage === "Broker") {
                application.background_color = "bg-yellow-light";
                break;
              }
            case 'Approved':
              application.background_color = "bg-green-light";
              break;
            case 'Fail':
              application.background_color = "bg-red-light";
              break;
            case 'Waiting for Docs':
              application.background_color = "bg-blue";
              break;
            default:
              application.background_color = "bg-white";
          }
        });
      }
      return applicationWithStages;
    }
  },
  watch: {
    selectedColumns: {
      deep: true,
      handler(val) {
        this.$store.commit('set_selected_pipeline_columns', val);
      }
    },
    display_items: {
      deep: true,
      handler(newDisplayItems) {
        if (this.selectedColumns.length === 0) {
          this.selectedColumns = this.selected_pipeline_columns()?.length > 0
            ? [...this.selected_pipeline_columns()]
            : Object.keys(newDisplayItems);
        }
        // Iterate through newDisplayItems and create new one in store if doesn't exist
        for (const key in newDisplayItems) {
          for (const application of newDisplayItems[key]) {
            if (!this.applicationData[application.id]) {
              this.$store.commit('set_current_next_action', {
                applicationId: application.id,
                nextAction: false,
                nextActionDate: null
              });
            }
          }
        }
      },
      immediate: true
    },
  },
  async created() {
    await this.fetchPaginatedApplications();
    // Set selectedColumns from Vuex or fallback
    this.selectedColumns =
      this.selected_pipeline_columns()?.length > 0
        ? [...this.selected_pipeline_columns()]
        : Object.keys(this.display_items);
    const allNextActionApplications = this.getAllApplicationsNextActionData;
    const today = Date.UTC(new Date().getFullYear(), new Date().getMonth(), new Date().getDate());
    if (allNextActionApplications) {
      for (const applicationId in allNextActionApplications) {
        if (allNextActionApplications[applicationId].nextAction === true) {
          // Convert to UTC timestamp for comparison
          const currentActionDateValue = new Date(allNextActionApplications[applicationId].nextActionDate).getTime();
          const currentActionDateUtc = Date.UTC(
            new Date(currentActionDateValue).getUTCFullYear(),
            new Date(currentActionDateValue).getUTCMonth(),
            new Date(currentActionDateValue).getUTCDate()
          );
          if (today > currentActionDateUtc) {
            // Disable the checkbox and set nextActionDate to null
            this.$set(this.checkboxVal, applicationId, false);
            this.$store.dispatch('updateApplicationNextAction', {
              applicationId,
              nextAction: false,
              nextActionDate: null,
            });
          } else {
            this.$set(this.checkboxVal, applicationId, true);
            // Move ones with next action date to bottom
            this.moveInfo.applicationIdToMove = applicationId;
            this.moveInfo.shouldMoveToBottom = true;
          }
        }
      }
    }
  },
  methods: {
    log: function (evt, column) {
      if(Object.keys(evt).includes('removed')) {
        this.removedElement = {...evt.removed, 'column': column};
        this.updateApplication(this.addedElement)
      }
      if (Object.keys(evt).includes('added')) {
        this.addedElement = {...evt.added, 'column': column};
      }
      this.checkColumn(this.addedElement.column);
    },
    getIncome(application){
      let totalIncome = 0;
      if (application.broker_incomes) {
        totalIncome = application.broker_incomes.reduce((sum, current) => sum + parseFloat(current.income_amount), 0);
      }
      if (application.insurances) {
        totalIncome = totalIncome + application.insurances.reduce((sum, current) => sum + ((current.income && current.enabled) ? parseFloat(current.income.replace(/,/g, '')) : 0), 0);
      }
      return totalIncome;
    },
    goToPage(page) {
      if (page < 1) {
        page = this.page_count + page + 1;
      }
      this.page = page;
    },
    handleCardClick(event, application) {
      const target = event.target;

      // Define a list of class names for elements that should NOT trigger editing
      const ignoredClasses = ['button-copy', 'date-picker', 'md-button'];

      // If the clicked element or any of its parents matches one of the ignored classes,
      // exit early to prevent triggering the redirewct to application
      if (ignoredClasses.some(cls => target.closest(`.${cls}`))) {
        return;
      }

      this.triggerEdit(application);
    },
    async fetchPaginatedApplications() {
      await this.$store.commit('set_pagination', {
        ...this.$store.state.pagination,
        page: this.page,
        per_page: this.items_per_page,
      });
      await this.$store.dispatch('fetch_work_basket');
      this.applications = [...this.$store.getters.work_basket];
      this.totalPages = this.page_count;
      this.classifyAppWithStatus();
    },
    nextPage() {
      if (this.page < this.totalPages) {
        this.page++;
        this.fetchPaginatedApplications();
      }
    },
    previousPage() {
      if (this.page > 1) {
        this.page--;
        this.fetchPaginatedApplications();
      }
    },
    changeItemsPerPage(newLimit) {
      this.items_per_page  = newLimit;
      this.page = 1;
      this.fetchPaginatedApplications();
    },
    classifyAppWithStatus() {
      this.applicationBasedOnStatus = {};
      if (this.userHasRole("Broker")) {
        for (let stage of this.brokerAppStages) {
          const applicationWithStatus = {};
          if (stage === 'Assigned To Broker') {
            applicationWithStatus['New'] = this.applications.filter(app => app.status.status === stage);
          } else if (stage === 'Compliance') {
            applicationWithStatus['Compliance'] = this.applications.filter(app =>
              app.status.stage === stage && ['Pass', 'Fail', 'Recheck'].includes(app.status.status)
            );
          } else if (stage === 'Settlement') {
            applicationWithStatus['In For Settlement'] = this.applications.filter(app =>
              app.status.stage === stage && app.status.status === 'In For Settlement' && app.status.reason === 'Other'
            );
            applicationWithStatus['Docs Generated'] = this.applications.filter(app =>
              app.status.stage === stage && app.status.status === 'Docs Generated' && app.status.reason === 'Other'
            );  
            applicationWithStatus['Docs Out'] = this.applications.filter(app =>
              app.status.stage === stage && app.status.status === 'Docs Out'
            );
            applicationWithStatus['Settled'] = this.applications.filter(app =>
              app.status.stage === stage && app.status.status === 'Settled'
            );
          } else if (stage === 'Approved/Conditional') {
            applicationWithStatus['Approved/Conditional'] = this.applications.filter(app =>
              ['Approved', 'Approved - Conditional'].includes(app.status.status)
            );
          } else {
            applicationWithStatus[stage] = this.applications.filter(app => app.status.status === stage);
          }
          this.applicationBasedOnStatus = {
            ...this.applicationBasedOnStatus,
            ...applicationWithStatus
          };
        }
      } else {
        for (let stage of this.appStages) {
          const applicationWithStatus = {};
          applicationWithStatus[stage] = this.applications.filter(app => app.status.stage === stage);
          this.applicationBasedOnStatus = {
            ...this.applicationBasedOnStatus,
            ...applicationWithStatus
          };
        }
      }
    },
    async handlePageChange() {
        await this.fetchPaginatedApplications(); 
        this.loadingPagination = false;
    },
    validateTime(applicationId) {
      const timeRegex = /^(0?\d|1\d|2[0-3]):(0?\d|[1-5]?\d)$/; // Regex for HH:mm format
      const hour = this.timeNextAction.hour[applicationId] || '00';
      const minute = this.timeNextAction.minute[applicationId] || '00';

      if (!timeRegex.test(`${hour}:${minute}`)) {
        this.$modal.show(AlertDialog, {
          title: 'Invalid time format',
          message: 'Please use HH:mm, Hours should not exceed 23, and minutes should not exceed 59.',
        });
        // reset checkbox
        this.checkboxVal[applicationId]= false
        this.handleCheckboxChange(applicationId);
        return false;
      }
      return true;
    },
    isCopied(text) {
      return this.copiedItems.includes(text);
    },
    async copyToClipboard(text) {
      try {
        await navigator.clipboard.writeText(text);

        // Remove the previously copied item (if any) and add the current item to the array
        this.copiedItems.pop();
        this.copiedItems.push(text);
      } catch (err) {
        console.error(`Unable to copy ${text} to clipboard`, err);
      }
    },
    handleCheckboxChange(applicationId) {
      Object.keys(this.datePickerVisibility).forEach((id) => {
        if (id !== applicationId) {
          this.$set(this.datePickerVisibility, id, false);
        }
      });

      this.$set(this.datePickerVisibility, applicationId, true);

      let nextActionDate = null;

      // Erase date and reset input hour minute if checkbox is unchecked
      if (!this.checkboxVal[applicationId]) {
        this.pickerVal[applicationId] = null;
        this.timeNextAction.hour[applicationId] = '00';
        this.timeNextAction.minute[applicationId] = '00';
      } else {
        // Set the date part from the pickerVal if it exists, or set it to today if not
        nextActionDate = this.pickerVal[applicationId]
        ? new Date(this.pickerVal[applicationId])
        : new Date();
        // Set the time part to midnight
        nextActionDate.setHours('00');
        nextActionDate.setMinutes('00');
        nextActionDate.setSeconds('00');
      }

      // Dispatch the action to update the application data with nextAction and nextActionDate
      this.$store.dispatch('updateApplicationNextAction', {
        applicationId,
        nextAction: this.checkboxVal[applicationId],
        nextActionDate
      });
    },
    handleFilterChange(applicationId) {
      // check if hour and minutes inputs have valid values
      if (!this.validateTime(applicationId)) {
        // Stop execution if validation fails
        return;
      }

      const pickerVal = this.pickerVal[applicationId];
      let nextActionDate = null;

      // Check if the checkbox is checked and a date is selected
      if (this.checkboxVal[applicationId] && pickerVal) {
        // If a date is selected, create a Date object using the picker value
        nextActionDate = new Date(pickerVal);
      } else {
        // If the checkbox is checked but no date is selected, set nextActionDate to today's date
        nextActionDate = new Date();
      }

      // Set the time to selected hour and minute or default to midnight
      nextActionDate.setHours(this.timeNextAction.hour[applicationId] || '00');
      nextActionDate.setMinutes(this.timeNextAction.minute[applicationId] || '00');
      nextActionDate.setSeconds(0);

      // Dispatch the action to update the application data with nextAction and nextActionDate
      this.$store.dispatch('updateApplicationNextAction', {
        applicationId,
        nextAction: this.checkboxVal[applicationId],
        nextActionDate
      });

      // Toggle the visibility of the date picker for the corresponding application
      this.$set(this.datePickerVisibility, applicationId, false);

      this.$modal.show(AlertDialog, {
          title: 'Saved Successfully',
          message: `Your Next Action time has been set to ${this.datetime(nextActionDate)}`,
      });

      // ensure DOM is updated adding small delay
      this.$nextTick(() => {
        setTimeout(() => {
          this.moveItemToBottom(applicationId);
        }, 0);
      });
    },
    moveItemToBottom(applicationId) {
      for (const columnName in this.display_items) {
        const applications = this.display_items[columnName];
        const index = applications.findIndex(app => app.id === applicationId);

        if (index !== -1) {
          // Remove the application from its current position
          const removedApplication = applications.splice(index, 1)[0];

          // Add the application to the bottom of the column
          applications.push(removedApplication);

          // Break the loop once the application is moved
          break;
        }
      }
    },
    toggleCommentIcon(applicationId) {
      // empty array
      this.showCommentIcons = []
      const index = this.showCommentIcons.indexOf(applicationId);
      if (index === -1) {
        this.showCommentIcons.push(applicationId);
      } else {
        // Application ID found in the array, remove it
        this.showCommentIcons.splice(index, 1);
      }
    },
    checkColumn (key) {
      switch (key) {
        //  Update the status and stage of the application when dragging
        case 'New':
          this.addedElement.element.status.status = 'Assigned To Broker'
          this.addedElement.element.status.stage = 'Broker'
          break;
        case 'In Progress':
          this.addedElement.element.status.status = 'In Progress'
          this.addedElement.element.status.stage = 'Broker'
          break;
        case 'Waiting for Info':
          this.addedElement.element.status.status = 'Waiting for Info'
          this.addedElement.element.status.stage = 'Broker'
          break;
        case 'Submitted':
          this.addedElement.element.status.status = 'Submitted'
          this.addedElement.element.status.stage = 'Broker'
          break;
        case 'Broker':
          this.addedElement.element.status.status = 'Assigned To Broker'
          this.addedElement.element.status.stage = 'Broker'
          break;
        case 'Approved/Conditional':
          this.addedElement.element.status.status = 'Approved'
          this.addedElement.element.status.stage = 'Broker'
          break;
        case 'Docs Out':
          this.addedElement.element.status.status = 'Docs Out'
          this.addedElement.element.status.stage = 'Settlement'
          break;
        case 'Docs Generated':
          this.addedElement.element.status.status = 'Docs Generated'
          this.addedElement.element.status.stage = 'Settlement'
          break;
        case 'Settled':
          this.addedElement.element.status.status = 'Settled'
          this.addedElement.element.status.stage = 'Settlement'
          break;
        case 'In For Settlement':
          this.addedElement.element.status.status = 'In For Settlement'
          this.addedElement.element.status.stage = 'Settlement'
          break;
        case 'Compliance':
          this.addedElement.element.status.status = 'Review'
          this.addedElement.element.status.stage = 'Compliance'
          break;
        default:
          break;
      }
    },
    ...filters,
    referrerName(owners) {
      return filters.name(owners.Referrer && owners.Referrer.user.name)
    },
    async getAppPermissions(application){
      let result = await axios.get(`/api/v1/application/${application.id}/getPermissions`);
      application.permissions = result.data;
    },
    async updateApplication(application) {
      await this.$store.dispatch('update_application_status', {
          application_id: application.element.id,
          stage: application.element.status.stage,
          status: application.element.status.status,
          reason: "Other",
          comment: "Status/stage updated to on Pipeline Board",
      });
    },
    // methods actions
    async triggerEdit(application) {
      await this.getAppPermissions(application);
      if (application.permissions[this.actions.update]) {
        this.triggerBlockingEvent(this.actions.update, application);
      }
    },
    triggerOpen(application) {
      if (application.permissions[this.actions.view]) {
        this.triggerBlockingEvent(this.actions.view, application);
      }
    },
    async triggerManageOwners(application) {
      if (await this.checkApplicationLock(application) === false) {
        return false;
      }
      if (application.permissions[this.actions.transfer]) {
        this.$emit(this.actions.manage_owners, application);
      }
    },
    triggerAttachment(application) {
      if (application.permissions[this.actions.view]) {
        this.triggerBlockingEvent(this.actions.attachments, application);
      }
    },
    async triggerUpdateStatus(application) {
      if (await this.checkApplicationLock(application) === false) {
        return false;
      }
      if (application.permissions[this.actions.update_status]) {
        this.$emit(this.actions.update_status, application);
      }
    },
    async triggerManageComment(application) {
      this.isLoading = true;
      await this.toggleCommentIcon(application.id)
      await this.getAppPermissions(application);
      if (await this.checkApplicationLock(application) === false) {
        return false;
      }
      if (application.permissions[this.actions.update_status]) {
        await this.$store.dispatch('open_comment_dialog', application);
      }
      this.isLoading = false;
    },
    triggerCloneApplication(application) {
      if (application.permissions[this.actions.update]) {
        this.$emit(this.actions.clone, application);
      }
    },
    triggerBlockingEvent(action, application) {
      try {
        this.isLoading = true;
        this.$emit(action, application);
      } catch (error){
        console.error(error);
      }
    },
    async checkApplicationLock(application) {
      if (this.userHasPermission('bypass-application-lock') === false
        && await this.$store.dispatch('check_application_lock', application.id) == false) {
        this.$notifications.notify({
          'message': this.current_lock.messages,
          'icon': 'lock',
          'timeout': 5000,
          'verticalAlign': 'top',
          'horizontalAlign': 'center'
        })
        return false
      }
    },
    getFilteredValues(application) {
      let values = [];
      // name
      if (application.name) {
        if (application.name[0].firstname === undefined || application.name[0].lastname === undefined) {
          values.push(application.name.toLowerCase());
        } else {
          values.push(application.name[0].firstname.toLowerCase(), application.name[0].lastname.toLowerCase());
        }
      }
      // referrer name
      const referrerName = this.referrerName(application.owners);
      if (referrerName) {
        values.push(referrerName.toLowerCase());
      }
      // phone
      values.push(application.contact_details.phone_number);
      // email
      values.push(application.contact_details.email.toLowerCase());
      return values;
    },
    syncScroll(event) {
      const topScrollElement = this.$refs.topscroll;
      const bottomScrollElement = this.$refs.bottomscroll;

      if (event.target === topScrollElement) {
        // When the top scroll is scrolled, sync the bottom scroll
        bottomScrollElement.scrollLeft = topScrollElement.scrollLeft;
      } else {
        // When the bottom scroll is scrolled, sync the top scroll
        topScrollElement.scrollLeft = bottomScrollElement.scrollLeft;
      }
    },
  },
  mounted() {
    // Add user moving through table with mouse horizontally
    const container = document.querySelector(".scrolls");
    let isDragging = false;
    let startX;

    container.addEventListener("mousedown", (e) => {
      isDragging = true;
      startX = e.pageX - container.scrollLeft;
    });

    container.addEventListener("mousemove", (e) => {
      if (!isDragging) return;

      if (e.target === container) {
        const x = e.pageX - startX;
        container.scrollLeft = x;
      }
    });

    container.addEventListener("mouseup", () => {
      isDragging = false;
    });

    this.$refs.topscroll.addEventListener('scroll', this.syncScroll);
    this.$refs.bottomscroll.addEventListener('scroll', this.syncScroll);
  },
  filters: {
    ...filters,
  },
  updated() {
    if (this.moveInfo.shouldMoveToBottom) {
      this.$nextTick(() => {
        this.moveItemToBottom(this.moveInfo.applicationIdToMove);
      });
    }
  },
  beforeDestroy() {
    // Make sure to remove the scroll event listeners when the component is destroyed
    this.$refs.topscroll.removeEventListener('scroll', this.syncScroll);
    this.$refs.bottomscroll.removeEventListener('scroll', this.syncScroll);
  },
};

</script>
<style lang="scss" scoped>
@import "../assets/scss/md-custom/_ausloans-colors.scss";

.pipeline-list {
  padding-left: 5px;
  padding-right: 5px;
}

.filter-toolbar {
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
}

.arrow-group {
  display: flex;
  gap: 4px;
}

.filter-field {
  flex: 2;
  max-width: 300px;
}

.page-selector {
  max-width: 120px;
  flex: 0 0 auto;
}

.narrow {
  max-width: 140px;
  flex: 0 0 auto;
}

.column-selector {
  flex: 2;
  max-width: 300px;
}

.text-right {
  text-align: right;
}

.card-currency-wrapper {
  display: flex;
  flex-direction: column;
  align-items: flex-end;
  padding-right: 0 !important;
  margin-right: 0 !important;
  text-align: right;
}

.card-veda-wrapper {
  display: flex;
  flex-direction: column;
  align-items: center;
}

.card-menu-wrapper {
  display: flex; 
  justify-content: space-between;
  margin: 5px;
  align-items: center;
}

.min-height-100 {
  min-height: 100%
}
.scrolls {
  flex-wrap: nowrap;
  overflow-x: auto;
  white-space: nowrap;
}

.row-space-between {
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.row-end {
  display: flex;
  justify-content: flex-end;
  align-items: center;
}

.boxed-category {
  display: inline-block;
  white-space: normal;
  vertical-align: top;
}

.horizontal-scroll {
  flex-wrap: nowrap;
  overflow-y: scroll;
  overflow-y: hidden;
}

.card-container {
  display: flex;
  justify-content: space-between;
  align-items: flex-end;
}

.long-text {
  text-overflow: ellipsis;
  overflow: hidden;
}

::v-deep .v-date-picker-table .v-btn.v-btn--active {
  color: #fff;
  background: #0014ff;
}

::v-deep .v-picker__title {
  display: none;
}

.date-picker {
  z-index: 100;
  box-shadow: 4px 8px 12px rgba(0, 0, 0, 0.5);
  margin-left: -100px !important;
  margin-top: 70px !important;
}

.card-app-id {
  margin: 15px 0px 0px -75px;
}


.text-bold {
  font-weight: bold;
}

.button-copy {
  border: 1px solid gray;
  border-radius: 5px;
  padding: 1.75px;
  font-size: 12px;
  margin-right: 5px;
}

.application-count {
  margin-left: 5px;
}

.grabbable {
  cursor: move;
  cursor: grab;
  cursor: -moz-grab;
  cursor: -webkit-grab;
}

.grabbable:active {
  cursor: grabbing;
  cursor: -moz-grabbing;
  cursor: -webkit-grabbing;
}

.card-content {
  -webkit-user-select: none;
  user-select: none;
  -webkit-user-drag: none;
}

.sticky-top {
  position: sticky;
  top: 0;
  background-color: white; /* You can change the background color as needed */
  z-index: 9;
}

.back-to-top {
  position: fixed;
  bottom: 40px; /* Adjust the distance from the bottom as needed */
  right: 40px; /* Adjust the distance from the right as needed */
  cursor: pointer;
  z-index: 1000;
  background-color: $ausloans-blue-light; /* Button background color */
  color: #fff; /* Button text color */
  border: none;
  border-radius: 50%;
  width: 50px; /* Button width */
  height: 50px; /* Button height */
  display: flex;
  align-items: flex-end;
  justify-content: center;
}

.back-to-top:hover {
  background-color: $ausloans-blue-hover; /* Button background color on hover */
}
.bg-white {
  background: #fff !important;
}

.bg-blue {
  background: $ausloans-blue-o40 !important;
}

.bg-orange-light {
  background: $ausloans-orange-light !important;
}

.bg-yellow-light {
  background-color: $ausloans-yellow-light !important;
}

.bg-green-light {
  background: $ausloans-green-light !important;
}

.bg-red-light {
  background: $ausloans-red-light !important;
}

.md-card-header {
  background: transparent !important;
}

.hour-container {
  display: flex;
  flex-direction: row;
  align-items: center;
  margin:-10px 0px 20px 0px;
}

.hour-container .md-input {
  background-color: white;
  border: 1px gray solid;
  border-radius: 4px;
  text-align: center;
  padding: 0px !important;
}

.hour-container span {
  font-size: 1.5em;
  color: black;
  margin: 5px 5px -5px 5px;
}

.save-button-field {
  background-color: white !important;
}

.save-button {
  width: 100px;
  margin-left: 20px;
}

.caption {
  padding: 0px 10px 20px;
  color: rgba(0, 0, 0, 0.6);
  font-weight: bold;
  text-align: start;

  & .count {
    font-weight: normal;
  }
}

/* Covering till biggest laptop size */
@media only screen and (max-width: 2256px) {
  .date-picker {
    margin-top: 50px !important;
    margin-left: -155px !important;
  }

  ::v-deep .v-picker__body {
    width: 200px !important;
  }

  .card-app-id {
    margin: 15px 0px 0px -125px;
  }

  .hour-container {
    width: 175px !important;
  }

  .save-button {
    margin-left: 15px;
  }
}
</style>

